import React, { useState } from "react";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import IconButton from "@mui/material/IconButton";
import DialogExportExcelSpreadsheet from "../dialogs/DialogExportExcelSpreadsheet";
import { useSnackbar } from "notistack";
import { gapi } from "gapi-script";
import Snackbar from "@mui/material/Snackbar";
import Alert from '@mui/material/Alert';
import Tooltip from "@mui/material/Tooltip";
import loadGoogleClient from "./LoadGoogleClient";
import * as XLSX from 'xlsx';


import { useProjectStore } from "../model/ProjectStore";


const ExportActualsToXLSX = () => {
  const project = useProjectStore();
  const [createSheetStarted, setCreateSheetStarted] = useState(false);
  const [createSheetCompleted, setCreateSheetCompleted] = useState(false);

  const [exportEvaOpen, setExportEvaOpen] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const handleCreate = () => {
    setExportEvaOpen(true);
  };

  const handleExportEVAClose = () => {
    setExportEvaOpen(false);
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setCreateSheetStarted(false);
    setCreateSheetCompleted(false);
  };

  const createSpreadsheet = (period) => {

    let alltasks = project.rootTaskPackage.depthFirstTraversal();

    alltasks.sort((a,b) => a.displayIndex - b.displayIndex);
    alltasks.shift(); //remove the root task package

    let sheetFormatData = alltasks.map(t => t.exportActuals(period));
    
    const max_cols = [
      { wch: 15 }, // wch = define by # of characters
      { wch: 40 }, 
      { wch: 10 },
      { wch: 15 },
      { wch: 25 },
      { wch: 100 } 
    ];

// Assign the array to your worksheet


    // 1. Create a new, blank workbook
    const workbook = XLSX.utils.book_new();

    // 2. Convert JSON data into a worksheet
    const worksheet = XLSX.utils.json_to_sheet(sheetFormatData);

    // 3. Append the worksheet to the workbook with a tab name
    XLSX.utils.book_append_sheet(workbook, worksheet, "Project");
    worksheet['!cols'] = max_cols;
    // 4. Generate the Excel file and trigger the automatic download
    const fileName = project.name + " EVA Actuals Period " + period + ".xlsx";
    XLSX.writeFile(workbook, fileName);
  };


  return (
    <div className="AddGoogleSheetButton">
      <Tooltip title="Export Spreadsheet" aria-label="Export Period Actuals To Excel">
        <IconButton onClick={() => handleCreate()} color="inherit">
          <NoteAddIcon />
        </IconButton>
      </Tooltip>
      <DialogExportExcelSpreadsheet
        open={exportEvaOpen}
        onCancel={handleExportEVAClose}
        onSave={createSpreadsheet}
      />
      
    </div>
  );
}

export default ExportActualsToXLSX;
